import React from 'react';
import PropTypes from 'prop-types';
import Form from '../../../components/user/vivero/viveroForm';
import Layout from '../../../components/layouts/verticalLayout';
import { useParams } from 'react-router-dom';

const ViveroFormPage = () => {
  let { uuid } = useParams();
  return <Layout body={<Form uuid={uuid} />} />;
};

ViveroFormPage.propTypes = {};

export default ViveroFormPage;
